import React from "react";
import CheckIcon from "@material-ui/icons/Check";
import "../MembershipPage.css";

const MembershipPlanCard = ({
    planType,
    planName,
    tagline,
    icon,
    features,
    paygPrice,
    paygLabel,
    monthlyPrice,
    monthlyLabel,
    isCurrentPayg,
    isCurrentMonthly,
    onSelectPayg,
    onSelectMonthly,
    onSelectFree,
    isFreePlan,
    singleMonthly,
    highlighted,
    contactSalesUrl,
    isCurrentPlan
}) => {
    const headerClass = `membership-card-header ${planType}`;
    const iconClass = `membership-plan-icon ${planType}`;
    const cardClass = `membership-card ${highlighted ? 'highlighted' : ''}`;

    const renderPricingOptions = () => {
        if (contactSalesUrl) {
            return (
                <div className="membership-pricing-options single">
                    <div className="membership-pricing-option">
                        <div className="membership-pricing-label">Pricing</div>
                        <div className="membership-pricing-amount">POA</div>
                        {isCurrentPlan ? (
                            <div className="membership-current-label">
                                <CheckIcon style={{ fontSize: 14 }} /> Current Plan
                            </div>
                        ) : (
                            <button
                                type="button"
                                className="membership-select-btn"
                                onClick={() => window.open(contactSalesUrl, '_self')}
                            >
                                Contact HG Sales
                            </button>
                        )}
                    </div>
                </div>
            );
        }

        if (isFreePlan) {
            return (
                <div className="membership-pricing-options single">
                    <div className="membership-pricing-option">
                        <div className="membership-pricing-amount">Free</div>
                        {isCurrentPayg || isCurrentMonthly ? (
                            <div className="membership-current-label">
                                <CheckIcon style={{ fontSize: 14 }} /> Current Plan
                            </div>
                        ) : (
                            <button 
                                type="button"
                                className="membership-select-btn"
                                onClick={onSelectFree}
                            >
                                Select Plan
                            </button>
                        )}
                    </div>
                </div>
            );
        }

        if (singleMonthly) {
            return (
                <div className="membership-pricing-options single">
                    <div className="membership-pricing-option">
                        <div className="membership-pricing-label">{monthlyLabel || "Pay Monthly"}</div>
                        <div className="membership-pricing-amount">
                            {monthlyPrice}{monthlyPrice !== "Free" && <small> per month</small>}
                        </div>
                        {isCurrentMonthly ? (
                            <div className="membership-current-label">
                                <CheckIcon style={{ fontSize: 14 }} /> Current Plan
                            </div>
                        ) : (
                            <button 
                                type="button"
                                className="membership-select-btn"
                                onClick={onSelectMonthly}
                            >
                                Select Plan
                            </button>
                        )}
                    </div>
                </div>
            );
        }

        return (
            <div className="membership-pricing-options">
                <div className="membership-pricing-option">
                    <div className="membership-pricing-label">{paygLabel || "Pay As You Go"}</div>
                    <div className="membership-pricing-amount">
                        {paygPrice} <small>per gig</small>
                    </div>
                    {isCurrentPayg ? (
                        <div className="membership-current-label">
                            <CheckIcon style={{ fontSize: 14 }} /> Current Plan
                        </div>
                    ) : (
                        <button 
                            type="button"
                            className="membership-select-btn"
                            onClick={onSelectPayg}
                        >
                            Select Plan
                        </button>
                    )}
                </div>
                <div className="membership-pricing-option">
                    <div className="membership-pricing-label">{monthlyLabel || "Pay Monthly"}</div>
                    <div className="membership-pricing-amount">
                        {monthlyPrice}{monthlyPrice !== "Free" && <small> per month</small>}
                    </div>
                    {isCurrentMonthly ? (
                        <div className="membership-current-label">
                            <CheckIcon style={{ fontSize: 14 }} /> Current Plan
                        </div>
                    ) : (
                        <button 
                            type="button"
                            className="membership-select-btn"
                            onClick={onSelectMonthly}
                        >
                            Select Plan
                        </button>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className={cardClass}>
            <div className={headerClass}>
                <div className={iconClass}>
                    {icon}
                </div>
                <div className="membership-plan-name">{planName}</div>
                <div className="membership-plan-tagline">{tagline}</div>
            </div>
            <div className="membership-card-features">
                <ul className="membership-feature-list">
                    {features.map((feature, index) => (
                        <li key={index} className="membership-feature-item">
                            <CheckIcon className="membership-feature-icon" style={{ fontSize: 16 }} />
                            <span>{feature}</span>
                        </li>
                    ))}
                </ul>
            </div>
            {renderPricingOptions()}
        </div>
    );
};

export default MembershipPlanCard;
